module.exports = __webpack_public_path__ + "static/Abacus_Mitarbeitergepräche_Prozess-4dbba93db43d2f874a9d918f6367397c.png";